var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.363,
    height: 41.307,
    viewBox: "0 0 197.363 41.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2796",
    "data-name": "Grupo 2796",
    transform: "translate(-116.9 -205.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5338",
    "data-name": "Caminho 5338",
    d: "M338.672,388.348q0,4.854,0,9.709a.753.753,0,0,0,.07.369.264.264,0,0,0,.471-.077c.131-.669.674-.787,1.183-.852a16.319,16.319,0,0,1,2.1-.092c1.78,0,3.559.06,5.339.044a12.269,12.269,0,0,0,3.983-.542,4.3,4.3,0,0,0,1.635-.932.725.725,0,0,0,.238-.558q-.007-9.638-.01-19.277a.558.558,0,0,0-.162-.412c-.171-.115-.316.042-.444.173a3.933,3.933,0,0,1-2.151,1.038,15.531,15.531,0,0,1-2.431.29c-1.463.045-2.928.016-4.392.007-.831-.006-1.664-.074-2.492-.041a10.25,10.25,0,0,0-1.865.271,2.244,2.244,0,0,0-.774.458.838.838,0,0,0-.3.717Q338.677,383.493,338.672,388.348Z",
    transform: "translate(-197.771 -152.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2792",
    "data-name": "Grupo 2792",
    transform: "translate(121.04 205.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5339",
    "data-name": "Caminho 5339",
    d: "M157.285,226.5l-2.13-.031c.106-7.211,2.185-12.751,6.18-16.465a19.305,19.305,0,0,1,13.214-4.842l-.122,2.126a17.439,17.439,0,0,0-11.661,4.293C159.226,214.88,157.381,219.9,157.285,226.5Z",
    transform: "translate(-155.155 -205.146)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2793",
    "data-name": "Grupo 2793",
    transform: "translate(140.023 205.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5340",
    "data-name": "Caminho 5340",
    d: "M347.852,226.5c-.1-6.6-1.941-11.616-5.481-14.919a17.438,17.438,0,0,0-11.661-4.293l-.122-2.126A19.3,19.3,0,0,1,343.8,210c3.995,3.714,6.074,9.254,6.18,16.465Z",
    transform: "translate(-330.588 -205.146)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5341",
    "data-name": "Caminho 5341",
    d: "M137.281,397.786c0-1.933.814-3.51,1.844-3.64v-.013h2.285v7.3h-2.285v-.013C138.1,401.3,137.281,399.719,137.281,397.786Z",
    transform: "translate(-18.176 -168.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9132",
    "data-name": "Ret\\xE2ngulo 9132",
    width: 1.462,
    height: 3.491,
    rx: 0.731,
    transform: "translate(116.9 227.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9133",
    "data-name": "Ret\\xE2ngulo 9133",
    width: 1.462,
    height: 3.491,
    rx: 0.731,
    transform: "translate(161.982 227.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5342",
    "data-name": "Caminho 5342",
    d: "M492.479,397.786c0-1.933-.814-3.51-1.844-3.64v-.013H488.35v7.3h2.285v-.013C491.664,401.3,492.479,399.719,492.479,397.786Z",
    transform: "translate(-331.255 -168.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5343",
    "data-name": "Caminho 5343",
    d: "M202.656,378.639a.838.838,0,0,0-.3-.717,2.244,2.244,0,0,0-.774-.458,10.25,10.25,0,0,0-1.865-.271c-.829-.033-1.661.035-2.492.041-1.464.01-2.929.038-4.392-.007a15.531,15.531,0,0,1-2.431-.29,3.933,3.933,0,0,1-2.151-1.038c-.129-.131-.274-.287-.444-.173a.559.559,0,0,0-.162.412q-.012,9.639-.01,19.277a.724.724,0,0,0,.238.558,4.3,4.3,0,0,0,1.635.932,12.269,12.269,0,0,0,3.983.542c1.779.015,3.559-.04,5.339-.044a16.309,16.309,0,0,1,2.1.092c.51.065,1.052.183,1.183.852a.264.264,0,0,0,.471.077.753.753,0,0,0,.07-.369q.005-4.854,0-9.709T202.656,378.639Zm-12.24,15.367a.346.346,0,1,1,.107-.251A.343.343,0,0,1,190.416,394.006Zm0-1.1a.346.346,0,1,1,.107-.251A.344.344,0,0,1,190.416,392.908Zm0-3.79a.346.346,0,1,1,.107-.251A.343.343,0,0,1,190.416,389.118Zm0-2.2a.346.346,0,1,1,.107-.251A.343.343,0,0,1,190.416,386.923Zm0-4.888a.346.346,0,1,1,.107-.251A.343.343,0,0,1,190.416,382.035Zm1.1,10.873a.346.346,0,1,1,.107-.251A.344.344,0,0,1,191.514,392.908Zm0-1.1a.346.346,0,1,1,.107-.251A.344.344,0,0,1,191.514,391.811Zm0-3.79a.346.346,0,1,1,.107-.251A.344.344,0,0,1,191.514,388.021Zm0-1.1a.346.346,0,1,1,.107-.251A.344.344,0,0,1,191.514,386.923Zm0-3.79a.346.346,0,1,1,.107-.251A.345.345,0,0,1,191.514,383.133Zm0-1.1a.346.346,0,1,1,.107-.251A.344.344,0,0,1,191.514,382.035Zm1.846,9.776a.346.346,0,1,1,.107-.251A.343.343,0,0,1,193.36,391.811Zm0-4.888a.346.346,0,1,1,.107-.251A.343.343,0,0,1,193.36,386.923Zm0-2.692a.346.346,0,1,1,.107-.25A.343.343,0,0,1,193.36,384.231Zm0-2.2a.346.346,0,1,1,.107-.251A.343.343,0,0,1,193.36,382.035Zm1.1,10.873a.346.346,0,1,1,.107-.251A.344.344,0,0,1,194.458,392.908Zm0-9.775a.346.346,0,1,1,.107-.251A.345.345,0,0,1,194.458,383.133Zm1.845,8.678a.346.346,0,1,1,.108-.251A.343.343,0,0,1,196.3,391.811Zm0-7.58a.346.346,0,1,1,.108-.25A.343.343,0,0,1,196.3,384.231Zm0-1.1a.346.346,0,1,1,.108-.251A.344.344,0,0,1,196.3,383.133Zm0-1.1a.346.346,0,1,1,.108-.251A.343.343,0,0,1,196.3,382.035Zm1.1,9.776a.347.347,0,1,1,.107-.251A.344.344,0,0,1,197.4,391.811Zm0-8.678a.346.346,0,1,1,.107-.251A.345.345,0,0,1,197.4,383.133Zm1.846,8.678a.346.346,0,1,1,.108-.251A.343.343,0,0,1,199.247,391.811Zm0-8.678a.346.346,0,1,1,.108-.251A.344.344,0,0,1,199.247,383.133Zm1.1-1.1a.347.347,0,1,1,.107-.251A.344.344,0,0,1,200.345,382.035Z",
    transform: "translate(-63.078 -152.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2794",
    "data-name": "Grupo 2794",
    transform: "translate(129.875 210.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5344",
    "data-name": "Caminho 5344",
    d: "M248.268,263.4a3.352,3.352,0,0,1,6.571.113,3.4,3.4,0,0,1,1.541,0,3.352,3.352,0,0,1,6.574-.1l1.721-1.1a10.11,10.11,0,0,0-18.128-.005Z",
    transform: "translate(-245.493 -256.675)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5345",
    "data-name": "Caminho 5345",
    d: "M256.363,316.373l-2.045,1.307a3.352,3.352,0,0,1-6.677-.179,3.4,3.4,0,0,0-1.443,0,3.352,3.352,0,0,1-6.679.156l-2.029-1.3v-.041a10.1,10.1,0,0,0-.24,6.64c1.442.033,2.887.009,4.331,0,.875-.005,1.752-.074,2.625-.041a11.336,11.336,0,0,1,1.964.271,2.394,2.394,0,0,1,.815.458.388.388,0,1,0,.622,0,2.338,2.338,0,0,1,.8-.458,10.937,10.937,0,0,1,1.928-.271c.857-.033,1.717.035,2.577.041,1.224.008,2.449.027,3.673.011a10.1,10.1,0,0,0-.223-6.615Z",
    transform: "translate(-236.803 -309.865)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2795",
    "data-name": "Grupo 2795",
    transform: "translate(170.897 224.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5346",
    "data-name": "Caminho 5346",
    d: "M631.088,383.925v17.066c0,1.664.061,3.419.121,4.418h-4.085l-.212-2.179h-.061a5.165,5.165,0,0,1-4.63,2.512c-3.51,0-6.324-3-6.324-7.6-.03-4.993,3.087-7.868,6.627-7.868a4.507,4.507,0,0,1,3.9,1.664h.061v-8.019Zm-4.6,12.951a7.414,7.414,0,0,0-.061-.817,2.763,2.763,0,0,0-2.693-2.27c-2.088,0-3.177,1.876-3.177,4.206,0,2.512,1.241,4.085,3.147,4.085a2.693,2.693,0,0,0,2.663-2.209,3.914,3.914,0,0,0,.121-1.059Z",
    transform: "translate(-615.897 -383.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5347",
    "data-name": "Caminho 5347",
    d: "M802.211,450.212c0,5.416-3.843,7.9-7.807,7.9-4.327,0-7.656-2.844-7.656-7.625s3.147-7.837,7.9-7.837A7.2,7.2,0,0,1,802.211,450.212Zm-10.712.151c0,2.542,1.059,4.448,3.026,4.448,1.785,0,2.935-1.785,2.935-4.448,0-2.209-.847-4.448-2.935-4.448C792.316,445.915,791.5,448.185,791.5,450.363Z",
    transform: "translate(-768.26 -436.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5348",
    "data-name": "Caminho 5348",
    d: "M959.118,447.852c0-2.179-.06-3.6-.121-4.872h3.964l.151,2.723h.121a4.346,4.346,0,0,1,3.994-3.056,4.733,4.733,0,0,1,.968.061v4.327a6.6,6.6,0,0,0-1.241-.121,2.957,2.957,0,0,0-3.147,2.33,5.428,5.428,0,0,0-.091,1.029v7.5h-4.6Z",
    transform: "translate(-921.87 -436.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5349",
    "data-name": "Caminho 5349",
    d: "M1074.312,388.492a2.31,2.31,0,0,1-2.481,2.3,2.317,2.317,0,1,1,.03-4.63A2.307,2.307,0,0,1,1074.312,388.492Zm-4.751,18.912v-14.8h4.6v14.8Z",
    transform: "translate(-1020.361 -385.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5350",
    "data-name": "Caminho 5350",
    d: "M1150.375,447.7c0-1.846-.06-3.419-.121-4.721h3.994l.212,2.027h.091a5.417,5.417,0,0,1,4.569-2.36c3.026,0,5.3,2,5.3,6.355v8.775h-4.6v-8.2c0-1.906-.666-3.208-2.33-3.208a2.455,2.455,0,0,0-2.33,1.725,3.162,3.162,0,0,0-.182,1.15v8.533h-4.6Z",
    transform: "translate(-1092.43 -436.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5351",
    "data-name": "Caminho 5351",
    d: "M1319.859,457.777l-.272-1.483h-.091a5.331,5.331,0,0,1-4.236,1.816,4.536,4.536,0,0,1-4.781-4.539c0-3.843,3.449-5.689,8.684-5.659V447.7c0-.787-.424-1.906-2.693-1.906a8.321,8.321,0,0,0-4.085,1.12l-.847-2.965a12.214,12.214,0,0,1,5.749-1.3c4.932,0,6.506,2.9,6.506,6.385v5.144a22.916,22.916,0,0,0,.212,3.6Zm-.545-6.99c-2.421-.03-4.3.545-4.3,2.33a1.652,1.652,0,0,0,1.815,1.755,2.513,2.513,0,0,0,2.391-1.694,3.3,3.3,0,0,0,.091-.787Z",
    transform: "translate(-1235.317 -436.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5352",
    "data-name": "Caminho 5352",
    d: "M1464.11,408.253v4.206h3.813v2.027h-3.813v7.9c0,1.816.514,2.844,2,2.844a5.927,5.927,0,0,0,1.543-.182l.121,2a6.516,6.516,0,0,1-2.36.363,3.69,3.69,0,0,1-2.875-1.12c-.756-.787-1.029-2.088-1.029-3.813v-7.989h-2.27v-2.027h2.27v-3.51Z",
    transform: "translate(-1367.979 -405.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5353",
    "data-name": "Caminho 5353",
    d: "M1562.445,452.186c.06,3.6,2.36,5.084,5.023,5.084a9.628,9.628,0,0,0,4.055-.757l.454,1.906a11.862,11.862,0,0,1-4.872.908c-4.509,0-7.2-2.965-7.2-7.383s2.6-7.9,6.869-7.9c4.781,0,6.052,4.206,6.052,6.9a10.094,10.094,0,0,1-.091,1.241Zm7.807-1.906c.03-1.695-.7-4.327-3.692-4.327-2.693,0-3.873,2.481-4.085,4.327Z",
    transform: "translate(-1457.75 -437.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5354",
    "data-name": "Caminho 5354",
    d: "M1715.687,458.729a9.809,9.809,0,0,1-4.206.847c-4.418,0-7.292-3-7.292-7.474a7.441,7.441,0,0,1,7.867-7.777,8.9,8.9,0,0,1,3.692.757l-.605,2.058a6.176,6.176,0,0,0-3.087-.7c-3.359,0-5.174,2.481-5.174,5.538,0,3.389,2.179,5.477,5.084,5.477a7.565,7.565,0,0,0,3.268-.726Z",
    transform: "translate(-1586.422 -437.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5355",
    "data-name": "Caminho 5355",
    d: "M1842.073,459.024l-.212-1.846h-.091a5.455,5.455,0,0,1-4.479,2.179,4.173,4.173,0,0,1-4.478-4.206c0-3.54,3.147-5.477,8.806-5.447v-.3c0-1.21-.333-3.389-3.329-3.389a7.3,7.3,0,0,0-3.813,1.089l-.605-1.755a9.089,9.089,0,0,1,4.811-1.3c4.479,0,5.568,3.056,5.568,5.991v5.477a20.613,20.613,0,0,0,.242,3.51Zm-.393-7.474c-2.9-.061-6.2.454-6.2,3.3a2.356,2.356,0,0,0,2.511,2.542,3.644,3.644,0,0,0,3.54-2.451,2.778,2.778,0,0,0,.151-.847Z",
    transform: "translate(-1701.129 -437.54)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.d4d86c15f2e572c9598d40b6b4e0cd18.svg";
export { ForwardRef as ReactComponent };